"use client";

import { createContext } from "react";

/** True after `posthog.init` `loaded` callback (recording enabled for this tab). */
export const PostHogReadyContext = createContext(false);
